import { makeStyles } from '@material-ui/core/styles';

export default function SylesCss() {
    return makeStyles(theme => ({
        textField: {
            width: "30%",
            marginLeft: "20px"
        },
    }));
};
